<template>

<div class="container mt-2 px-1 bg-branco" :class="{ 'cont1': paginaCategoria }" style="margin-bottom: 100px">


    <div id="div-top mb-2">

    </div>

    <div class="text-center ">

        <img :src="dados.imagem_url" class="rounded mx-auto d-block " style="width: 200px" alt="">
        <h1 class="my-3" :class="{ 'cont1': paginaCategoria }" style="border: none">Cardápio</h1>

    </div>



    <div v-if="paginaCategoria" >
        <div class="containerCategoria">
            <div class="containerItemCategoria" v-for="categoria in categorias" :key="categoria.id">
                <div class="itemCategoria text-center" data-dismiss="modal" v-on:click="mudarCategoria(categoria.id)">
                    <img v-if="categoria.imagem_url" :src=categoria.imagem_url alt="Imagem">
                    <span>{{ categoria.nome }}</span>
                </div>
            </div>
        </div>
    </div>

    <div v-else class="cont2">

        <div class="sticky-top mb-5 no-print" style="overflow-x: auto">

            <div class="topo_fixo p-1">

                <button type="button" class="btn btn-dark" v-on:click="paginaCategoria = true">Alterar Categoria</button>

            </div>

        </div>

        <div class="table-responsive" v-for="categoria in filtroCategoria" :key="categoria.id">

            <h2 :id="'cat_'+categoria.id">{{categoria.nome}}</h2>
            <table class="table">
                <thead>
                    <tr>
                    <th >Nome</th>
                    <th width="90px" class="text-right">Preço</th>
                    </tr>
                </thead>
                <tbody>

                    <tr v-for="produto in categoria.produtos.filter(function (prod) { return prod.cardapio === 1}).sort((a,b) => a.ordem - b.ordem)" :key="produto.id">
                        <th>

                            <a class="link-style-none" href="#" v-on:click="ativarProduto(produto)" data-toggle="modal" data-target="#modalExemplo">
                                <div class="media">
                                    <img v-if="produto.imagem" class="mr-3 img-thumbnail" :src="produto.imagem" style="max-height: 72px ; max-width: 72px" >

                                    <div class="media-body">

                                        <h6 class="mt-0" style="border: none">{{produto.nome}}</h6>
                                        <span style="font-weight:normal; font-size:12px">{{produto.descricao}}</span>

                                    </div>

                                </div>
                            </a>

                        </th>
                        <td class="text-right">R$: {{produto.valor}}</td>
                    </tr>



                </tbody>
            </table>
        </div>


    </div>




    <br>
    <br><br>

    <detalhes :produto="produtoAtivo"></detalhes>


</div>

</template>

<script>
import api from "../service/api";
export default {
    data() {
        return {
            nome: 'Valdir',
            categoriaAtiva: "",
            categorias: null,
            novacat:null,
            filtroCategoria: null,
            dados: null,
            produtoAtivo: null,
            paginaCategoria: true
        }
    },

    mounted() {

        this.carregarCategorias();
        this.carregarDados();

        // Detecte o fechamento do modal
        $('#addCarrinho').modal('hide');

        // Detecte o fechamento do modal
        $('#modalCategoria').modal('show');


        $('#modalCategoria').on('hidden.bs.modal', () => {
            // Role o elemento pai do componente Vue para o topo
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

    },

    watch: {
        // sempre que a Categoria Ativa mudar, essa função será executada
        categoriaAtiva: function (n) {
            if (n==null) {
                this.filtroCategoria = this.categorias
            }else{
                this.filtroCategoria = this.categorias.filter(function (cate) {
                    return cate.id === n
                });
            }

            // this.verificarAncora("cat_"+n)

            // setTimeout(() => {
            //     console.log("cat_"+n)
            //     this.verificarAncora("cat_"+n)
            // }, 3000);

        }


    },

    methods: {
        mudarCategoria: function(cat){
            this.categoriaAtiva = cat;

           // Verifique se a URL atual já contém uma âncora
           const currentURL = window.location.href;
            const hasAnchor = currentURL.includes("#")

            // Crie uma variável para a âncora que você deseja adicionar
            const minhaAncora = "div-top";

            // Redirecione o usuário de acordo com a presença da âncora na URL atual
            if (hasAnchor) {
            // Se a URL já contiver uma âncora, remova-a e adicione a nova âncora
            const newURL = currentURL.replace(/#.*$/, `#${minhaAncora}`);
            window.location.href = newURL;
            } else {
            // Se a URL não tiver uma âncora, adicione-a normalmente
            window.location.href = currentURL + `#${minhaAncora}`;
            }

            this.paginaCategoria = false
        },

        ativarProduto: function(prod){
            this.produtoAtivo = prod
        },

        compare: function(a,b) {
            return a.valor - b.valor
        },

        async carregarCategorias(){
            await api
            .get('/listarCardapio')
            .then((response )=> {

                var categorias = response.data.filter(function (cate) {
                    return cate.disponivel === 1
                });

                this.categorias = categorias;

                this.filtroCategoria = categorias;

                console.log(this.filtroCategoria );
            });
        },

        async carregarDados(){
          await api
          .get('/inquilino')
          .then(response => (this.dados = response.data));
        },
    }
}
</script>

<style scoped >

.bg-branco{
    background-color: #fff;
    border-radius: 15px;
}

.link-style-none{
    color: black;
    text-decoration: none;
}

.cont1{
    background-color: var(--bg4);
    color: var(--txt4);
}

.cont2{
    background-color: #fff;
}

.containerItemCategoria{
    background-color: var(--btnbg4);
    border-radius: 10px;
    border: 2px solid #ffffff;
    margin: 10px 0;
}

.containerItemCategoria:nth-child(odd) .itemCategoria {
    background: linear-gradient(45deg, #ffffff31, #ffffff00);
}

/* ---------------------------------------- */

.topo_fixo{
    background: #ececec;
}

#div-top{
    height: 20px;
    margin-bottom: 20px;
}

.containerCategoria {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.itemCategoria {
    display: flex;
    align-items: center; /* Alinhar verticalmente no meio */
    width: 100%;
    height: 100px;
    background: linear-gradient(45deg, #ffffff00, #ffffff31);
    color: var(--btntxt4);
    font-size: 18px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    cursor: pointer;
}

.itemCategoria img {
    min-width: 130px;
    height: 100px;
    margin-right: 20px;
    border-top-left-radius : 10px;
    border-bottom-left-radius: 10px;
    object-fit: cover; /* Mantém a proporção da imagem e corta os cantos */
}

.itemCategoria span {
    width: 100%;
    text-align: center; /* Centraliza o texto horizontalmente */
    font-size: 18px;
}



@media print {
/* Oculta as divs que você não deseja imprimir */
    .no-print {
        display: none;
    }

    /* Define o layout da página de impressão */
    body {
        font-size: 12pt;
        margin: 0;
        padding: 0;
    }
}

</style>
